/* eslint-disable */
import dicts from './example'

// 祖统工作记录-表单
export const branchUnityForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        rules: {
            // brandInfo: [
            //     { required: true, message: '请输入', trigger: 'blur' },
            // ],
            // unityJob: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // activeWork: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
            // carryTime: [
            //     {
            //         required: true,
            //         message: '请选择',
            //         trigger: 'change',
            //     },
            // ],
        },
    },
    items: [
        {
            label: '已有祖统工作品牌',
            prop: 'brandInfo',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            type: 'select',
            label: '持续开展时间',
            prop: 'carryTime',
            options: dicts.carryTime(),
        },
        {
            type: 'select',
            label: '维护祖国和平统一，积极开展相关工作',
            prop: 'unityJob',
            options: dicts.whether(),
        },
        {
            type: 'select',
            label: '是否及时反映祖统工作信息',
            prop: 'activeWork',
            options: dicts.whether(),
        },
    ],
}

// 祖统工作记录-表格
export const branchUnityCols = [
    {
        title: '已有祖统工作品牌',
        key: 'brandInfo',
        tooltip: true,
        minWidth: 180,
    },
    {
        title: '持续开展时间',
        slot: 'carryTime',
        tooltip: true,
        width: 150,
    },
    {
        title: '维护祖国统一,积极开展相关工作',
        slot: 'unityJob',
        width: 300,
    },
    {
        title: '是否及时反映祖统工作信息',
        slot: 'activeWork',
        width: 240,
    },
    {
        title: '操作',
        slot: 'operation',
        width: 160,
        fixed: 'right',
        align: 'center'
    }
]
